
define('unknown/unknownSetup',[
	'jquery',
	'underscore',
	'module',
], function($, _, module){
	var initialize = function(){
		//!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+"://platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","twitter-wjs");
		
		$('#navButton').on('click', function(){$('#navLinkMenu').toggleClass('open');});
		
		var path = window.location.pathname;
		
		if(path == '/draftapp/' || path == '/draftapp' || path == '/' || path == ''){
			$('.homeTopperLink').addClass('active');
		} else if(path.indexOf('/draftapp/page/features', 0) > -1){
			$('.featureTopperLink').addClass('active');
		} else if(path.indexOf('/draftapp/page/pricing', 0) > -1){
			$('.pricingTopperLink').addClass('active');
		} else if(path.indexOf('/draftapp/page/faq', 0) > -1){
			$('.faqTopperLink').addClass('active');
		} else if(path.indexOf('/draftapp/page/contact', 0) > -1){
			$('.contactTopperLink').addClass('active');
		} else if(path.indexOf('/draftapp/auth', 0) > -1){
			$('.loginTopperLink').addClass('active');
		}
		
		var loginStatusJSON = $.parseJSON(module.config().loginStatusJSON);
		
		//If the user is logged in, change up some of the links to reflect that
		if(loginStatusJSON.userName 
				&& loginStatusJSON.userName != "" 
				&& loginStatusJSON.userName != "guest"){
			$('.registerTopperLink').hide();
			$('.loginTopperLink').hide();
			$('.dashboardTopperLink').show();
			$('.logoutTopperLink').show();
			
			$('.registerFooterLink').hide();
			$('.loginFooterLink').hide();
			$('.dashboardFooterLink').show();
			$('.logoutFooterLink').show();
			
			if($('.crtDraftBoardCTA')){
				$('.crtDraftBoardCTA').attr("href", "/draftapp/dashboard/leagues/create");
			}
		}
	};
	
	return {
		initialize: initialize
	};
});